import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {FBRepeater} from "./FBRepeater";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {FBRepeaterModel} from "./FBRepeater.Model";
import {FBRepeaterOptions} from "./FBRepeater.Options";
import {FBColumnOptions} from "FormBuilder/Core/FBColumn.Options";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {SingleEvent} from "shared/utilities/Events/SingleEvent";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {PublishOnceEvent} from "shared/utilities/Events/PublishOnceEvent";
import {PriceManager} from "FormBuilder/Utilities/Managers/PriceManager/PriceManager";
import {FBFieldBaseOptions} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GroupCalculator} from "FormBuilder/Core/Calulators/GroupCalculator";
import {FBRepeaterItemOptions} from "./FBRepeaterItem.Options";


export class FBRepeaterItemModel extends FBFieldWithPriceBaseModel<FBRepeaterItemOptions, FBColumnModel> implements ContainerDataRetriever{
    public static LastId=0;
    FieldValueChanged: SingleEvent<FBFieldBaseModel>;
    IsField: boolean;
    IsLoaded: boolean;
    OnLoad: PublishOnceEvent;

    public ShowAddButton:boolean;
    PriceManager: PriceManager;
    ProductPriceChanged: SingleEvent;
    VariationChanged: SingleEvent;
    Rows:FBRowModel[];
    OnAdd:SingleEvent;
    OnRemove:SingleEvent;

    private localPreviousData:any;

    constructor(Options: FBRepeaterItemOptions, Parent: FBColumnModel,previousData:any=null) {
        super(Options, Parent,previousData);
        this.localPreviousData=previousData;
        this.OnAdd=new SingleEvent();
        this.OnRemove=new SingleEvent();
        if(this.Options.Id==0&&!this.Parent.IsDesign)
        {
            FBRepeaterItemModel.LastId++;
            this.Options.Id=FBRepeaterItemModel.LastId;
        }

        this.FieldValueChanged=new SingleEvent();
        this.FieldValueChanged.Subscribe(this,()=>this.OnFieldValueChanged())

        this.IsField=true;
        this.OnLoad=new PublishOnceEvent();
        this.ProductPriceChanged=new SingleEvent();
        this.PriceManager=new PriceManager(this);

        let previousValues:string[][]=this.GetPreviousDataProperty('Value',[]);
        let quantity=this.GetPreviousDataProperty( 'Quantity',this.ParseNumber(this.Options.QuantityDefaultValue));
        if(quantity==0)
            quantity=1;
        this.PriceManager.UpdateQuantity(quantity);
        this.calculator=new GroupCalculator(this.PriceManager);
        this.calculator.Initialize(this);
        this.Quantity=quantity;

        if(this.FormBuilder.VariationChanged!=null)
            this.FormBuilder.VariationChanged.Subscribe(this,()=>this.VariationChanged.Publish());

        this.Rows=[];
        for(let row of this.Options.Rows)
            this.Rows.push(new FBRowModel(row,this));
    }

    public ExecuteFirstCalculation(){
        this.GetFields().forEach(field=>{
            if(field instanceof FBFieldWithPriceBaseModel)
            {
                if((field as any).ExecuteFirstCalculation!=null)
                    (field as any).ExecuteFirstCalculation();


                let fieldCalculator=field as FBFieldWithPriceBaseModel;
                if(!fieldCalculator.calculator.GetDependsOnOtherFields())
                {
                    fieldCalculator.calculator.ExecuteAndUpdate();
                }

                if(fieldCalculator.calculator.GetDependsOnOtherFields())
                {
                    fieldCalculator.calculator.ExecuteAndUpdate();
                }
            }
        })
    }

    protected InitializePriceCalculator() {

    }

    public Recreate(){

    }

    GetStoresInformation(): boolean {
        return true;
    }


    public get PreviousData(){
        if(this.localPreviousData!=null)
            return {Fields:this.localPreviousData};
        return {Fields:this.GetPreviousDataProperty('Value',[])};
    }

    public CreateSubRow(options:FBRowModel)
    {
        return this.FormBuilder.CreateSubRow(options);
    }

    public DeleteField(field: FBFieldBaseModel) {
        let row=FBRowOptions;

        for(let currentRow of this.Rows)
        {
            if(currentRow.Columns.find(x=>x.Field==field)!=null)
            {
                this.Rows.splice(this.Rows.indexOf(currentRow),1);
                this.Refresh();
            }
        }
    }


    public GetValue() {
        let values:any[]=[];
        for(let row of this.Rows)
        {
            if(row.Columns[0].Field.GetIsUsed())
            {
                values.push(row.Columns[0].Field.SerializeEntry());
            }
        }

        return values;


    }


    protected InternalSerialize(obj: any) {
        super.InternalSerialize(obj);
        obj.Value=this.GetValue();
    }


    GetDynamicFieldNames(): string[] {

        let dynamics= ['FBGroupPanel'];

        for(let field of this.GetFields())
        {
            if(field.GetDynamicFieldNames().length>0)
                dynamics=dynamics.concat(field.GetDynamicFieldNames());
        }
        return dynamics;
    }

    GetSalePrice(): any {
        return this.FormBuilder.GetSalePrice();
    }

    GetIsUsed(): boolean {

        return this.Options.Rows.length>0;
    }



    GetFieldById(id: any): FBFieldBaseModel<FBFieldBaseOptions, FBColumnModel> {
        return undefined;
    }

    GetFields(): FBFieldBaseModel[] {
        let fields:FBFieldBaseModel[]=[];
        this.Rows.map(row=>row.Columns.map(column=>fields.push(column.Field)));
        return fields;
    }



    GetNextFieldId(): number {
        return this.FormBuilder.GetNextFieldId();
    }


    GetProductPrice(): any {
        return this.FormBuilder.GetProductPrice();
    }

    GetRowByFieldId(fieldId:number): FBRowModel {
        return this.FormBuilder.GetRowByFieldId(fieldId)
    }

    GetRows(): FBRowModel[] {
        return this.Rows;
    }



    GetRuler(): any {
        return (this.FormBuilder as ContainerDataRetriever).GetRuler();
    }

    public GetVariationValue(VariationName:string)
    {
        return (document.querySelector('#'+VariationName.toLowerCase()) as HTMLSelectElement).value;
    }


    private OnFieldValueChanged() {
        this.FormBuilder.FieldValueChanged.Publish(this);
    }

    GetId(): string {
        return this.Options.Id.toString();
    }

    GetPluginURL(): any {
        return this.FormBuilder.GetPluginURL();
    }
}
